<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App',
  mounted() {
    // Check for saved theme preference or default to light
    const savedTheme = localStorage.getItem('theme') || 'light';
    this.setTheme(savedTheme);
  },
  methods: {
    setTheme(theme) {
      if (theme === 'dark') {
        document.documentElement.classList.add('dark');
      } else {
        document.documentElement.classList.remove('dark');
      }
      localStorage.setItem('theme', theme);
    }
  },
  created() {
    // Listen for theme change events
    this.$emitter.on('theme-changed', this.setTheme);
  },
  beforeUnmount() {
    this.$emitter.off('theme-changed', this.setTheme);
  }
}
</script>

<style>
#app {
  min-height: 100vh;
  width: 100%;
  max-width: 100%;
}
</style>
